export default __webpack_public_path__ + "static/media/53.603b385a.jpg";